module.exports = __webpack_public_path__ + "img/round1-test4.897105e6.jpg";